import(/* webpackMode: "eager", webpackExports: ["ChildLayout"] */ "/vercel/path0/academy-ui/src/components/layout/ChildLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/tailwindcss/tailwind.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/academy-ui/src/app/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationProvider"] */ "/vercel/path0/shared/web-core/src/ui/contexts/NotificationContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/shared/web-core/src/utils/StyledComponentsRegistry.tsx");
